import axios from "axios";
import { dataURItoBlob } from "@rjsf/core/lib/utils";
export const getApplicationConfig = (apiUrl) => axios.get(apiUrl);

export const sendEmail = ({
  attachments,
  html,
  subject,
  recipients,
  from,
  endpoint = "/i10/public/i10ds10/api/v1/notification/",
  metadata = {},
}) => {
  const notificationParameters = {
    templateName: "INTERNAL_MAIL_EDOK",
    from: from,
    informationType: "Skadehandling",
    type: "MAIL",
    to: recipients,
    metadata,
    parameters: {
      text: html,
      subject,
    },
  };
  // Create a form to send the data to the folksam-notification server
  let form = new FormData();

  // Construct the data for notification
  const data = new Blob([JSON.stringify(notificationParameters)], {
    type: "application/json",
  });

  // Append it to the form
  form.append("data", data, "blob");

  // For each Attachment append it to the form
  attachments.forEach((file) => {
    const { name, blob } = dataURItoBlob(file);
    form.append("attachments", blob, name);
  });

  return axios.post(endpoint, form, {
    headers: {
      "Content-type": "application/json",
    },
  });
};
